//import './App.css';
import React, { Component, useLayoutEffect, useRef } from "react";
import "./App.scss";
import CloudMachine from "./components/LongCloud1";
import Navbar2 from "./components/dissapearingNavBar";
import Hero from "./components/hero";
import About from "./components/about";
import Experience from "./components/experience";
import Contact from "./components/contact";
import { useEffect } from "react";

class App extends Component {
  render() {
    return (
      <div className="App">
        <Navbar2 />
        <CloudMachine />
        <div id="content">
          <Hero />
          <About />
          <Experience />
          <Contact />
        </div>
      </div>
    );
  }
}

export default function ResumeRedirect() {
  useEffect(() => {
    window.location.replace("https://mackenziemay.me/resume.pdf");
  }, []);

  return (
    <div className="flex flex-col items-center justify-center h-screen text-center">
      <p className="text-lg font-medium">Redirecting to résumé...</p>
      <a href="https://mackenziemay.me/resume.pdf" className="mt-4 text-blue-600 underline">
        Click here if it doesn’t happen automatically
      </a>
    </div>
  );
}

//export default App;
